module.exports = __webpack_public_path__ + "img/4.997b3917.jpg";